import styled from "styled-components";

const ButtonGroup = styled.div`
  display: flex;
  justify-content: center;
  margin: 40px 0;

  & button {
    font-size: 14px;
  }
`;

export default ButtonGroup;